import React from 'react';
import { styled } from 'styletron-react';
import { TechemTheme } from '@techem/techem-theme';
import { useAppSelector } from '../../store';

type AcceptDataProcessingTermsCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
};

const InlineLink = styled('a', {
  color: TechemTheme.colors.primary + ' !important',
  userSelect: 'none',
  cursor: 'pointer',
  ':focus': {
    textDecoration: 'underline',
    color: TechemTheme.colors.primary + ' !important'
  },
  ':hover': {
    textDecoration: 'underline',
    color: TechemTheme.colors.primary + ' !important'
  }
});

// TODO: Change text
const AcceptDataProcessingTermsCheckbox: React.FC<AcceptDataProcessingTermsCheckboxProps> = ({
  checked,
  onChange
}) => {
  const dpaVersion = useAppSelector((state) => state.misc.dataProcessingAgreement?.url || '');

  return (
    <label>
      <input
        type="checkbox"
        style={{ marginRight: '8px' }}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      Ich stimme dem{' '}
      <InlineLink href={dpaVersion} target="_blank" rel="noopener noreferrer">
        Aufragsverarbeitungsvertrag (AVV)
      </InlineLink>{' '}
      zu.
    </label>
  );
};

export default AcceptDataProcessingTermsCheckbox;
